export const ALL_PRODUCT_REQUEST="ALL_PRODUCT_REQUEST";
export const ALL_PRODUCT_SUCCESS="ALL_PRODUCT_SUCCESS";
export const ALL_PRODUCT_FAIL="ALL_PRODUCT_FAIL"; 

export const PRODUCT_DETAIL_REQUEST="PRODUCT_DETAIL_REQUEST";
export const PRODUCT_DETAIL_SUCCESS="PRODUCT_DETAIL_SUCCESS";
export const PRODUCT_DETAIL_FAIL="PRODUCT_DETAIL_FAIL";

export const PRODUCT_REVIEW_REQUEST="PRODUCT_REVIEW_REQUEST";
export const PRODUCT_REVIEW_SUCCESS="PRODUCT_REVIEW_SUCCESS";
export const PRODUCT_REVIEW_FAIL="PRODUCT_REVIEW_FAIL"; 
export const PRODUCT_REVIEW_RESET="PRODUCT_REVIEW_RESET";

export const CLEAR_ERRORS="CLEAR_ERRORS"; 